import {
  SET_ORDER,
  SET_STATUS_ORDER,
  SET_TEXTES_ORDER,
  SET_MODES_PAYEMENT,
  SET_MODES_LIVRAISON,
  SET_TYPE_PRODUCTS,
  SET_ORDER_ORIGINAL,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
  order: null,
  orderOriginal: null,
  textes: null,
  status_order: [],
  modes_payement: [],
  modes_livraison: [],
  type_products: [],
}

// mutations
const mutations = {
  [SET_ORDER](state, message) {
    state.order = message;
  },
  [SET_ORDER_ORIGINAL](state, message) {
    state.orderOriginal = message;
  },
  [SET_STATUS_ORDER](state, message) {
    state.status_order = message;
  },
  [SET_MODES_PAYEMENT](state, message) {
    state.modes_payement = message;
  },
  [SET_MODES_LIVRAISON](state, message) {
    state.modes_livraison = message;
  },
  [SET_TYPE_PRODUCTS](state, message) {
    state.type_products = message;
  },
  [SET_TEXTES_ORDER](state, message) {
    state.textes = message;
  },
}

const actions = {
  setOrder({commit}, msg) {
    commit(SET_ORDER, msg)
  },
  setOrderOriginal({commit}, msg) {
    commit(SET_ORDER_ORIGINAL, msg)
  },
  setStatusOrder({commit}, msg) {
    commit(SET_STATUS_ORDER, msg)
  },
  setModesPayement({commit}, msg) {
    commit(SET_MODES_PAYEMENT, msg)
  },
  setModesLivraison({commit}, msg) {
    commit(SET_MODES_LIVRAISON, msg)
  },
  setTypeProducts({commit}, msg) {
    commit(SET_TYPE_PRODUCTS, msg)
  },
  setTextesOrder({commit}, msg) {
    commit(SET_TEXTES_ORDER, msg)
  },
}

const getters = {
  getOrder: state => {
    return state.order;
  },
  getOrderOriginal: state => {
    return state.orderOriginal;
  },
  getStatusOrder: state => {
    return state.status_order;
  },
  getModesPayement: state => {
    return state.modes_payement;
  },
  getModesLivraison: state => {
    return state.modes_livraison;
  },
  getTypeProducts: state => {
    return state.type_products;
  },
  getTextesOrder: state => {
    return state.textes;
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/store-order.js